const paymentHistoryEn = {
    paymentHistory: require('../../lang/en/payment_history/PaymentHistory').default,
};

export default paymentHistoryEn;
